const translations = {
    accepted: 'Accepted',
    button: 'Transfer Organization Ownership',
    inReview: 'In Review',
    title: 'Organization Details'
};

export default translations;
